module.exports = __webpack_public_path__ + "static/media/2200dfff-da50-40b0-bc12-5e4b872a1998.56b04aec.woff2";